<template>
	<div class="feedback-container">
        <!-- 表单内容 -->
        <div class="form-content">
            <!-- 页面标题 -->
            <div class="page-header">
                <van-icon :name="feedback" size="48px" class="header-icon" />
                <h1 class="header-title">新意见建议</h1>
                <p class="header-subtitle">感谢您的宝贵意见</p>
            </div>

            <!-- 表单区域 -->
            <div class="form-section">
                <van-field 
                    v-model="msgTopic" 
                    placeholder="请输入建议主题" 
                    label="建议主题" 
                    required
                    class="form-field"
                />
                
                <van-cell 
                    is-link 
                    title="问题分类" 
                    :value="qatype" 
                    @click="show = true"
                    class="form-cell left-align"
                />
                <van-action-sheet
                    v-model="show"
                    :actions="qatypies"
                    cancel-text="取消"		
                    @cancel="onCancel"
                    @select="onSelect"
                />	  
                
                <van-field 
                    v-model="msgContent" 
                    placeholder="请输入详细的建议内容..." 
                    label="建议内容" 
                    rows="6"
                    type="textarea" 
                    autosize 
                    required
                    class="form-field textarea-field"
                />		
            </div>

            <!-- 提交按钮 -->
            <div class="action-section">
                <van-button 
                    type="primary" 
                    size="large" 
                    class="submit-btn" 
                    @click="submit"
                >
                    提交建议
                </van-button>
            </div>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {Dialog} from 'vant'	
	import QS from 'qs'
	
	export default {
	  name: 'FEEDBACK',	  
	  data(){
		  return{
			  feedback: require("@/assets/icon/feedback2.png"),
			  msgTopic:'',
			  msgContent:'',
			  show:false,
			  qatype:'请选择一个问题分类',
			  qatypeid:'',
			  qatypies:[],
			  disabled:true
		  }
		},
	created(){
		this.getQATypes();
		this.$root.myTitle ='新建议反馈';
	},
	 methods:{
		 onCancel(){
			 this.show = false;
		 },
		 onSelect(item){
			 this.show = false;			 
			 this.qatype = item.name;
			 this.qatypeid = item.submame;
		 },
		 getQATypes(){
			 var that = this
			 Vue.axios.get( that.global.BASE_URL_T3 +  '/api/vop/qatypes')
			  .then(function (response) {
			   var totalrows = response.data.Data.length;
			   for(var i = 0; i < totalrows; i++) {
			   	that.qatypies.push({
                    name:response.data.Data[i].qatype,
                    submame:response.data.Data[i].qatypeid
                })
			   }	
			   console.log(that.qatypies)
			  })
			  .catch(function (error) {
			   console.log(error);
			  }) 
		 },
		 checkInput(){
		 	var result = 0;
		 	if (this.msgTopic == '') result++;
		 	if (this.qatypeid == '') result++;
		 	if (this.msgContent == '') result++;
		 	return result;
		 },
		 submit(){
			 let that = this			 
			 if (that.checkInput() == 0){			 	
			 Dialog.confirm({
			   message: '确认发送意见反馈？'
			 }).then(() => {
			   // on confirm	
			  var data = QS.stringify({
			   	msgtitle:that.msgTopic,
			   	msgtypeid:that.qatypeid,
			   	msg:that.msgContent,
			   	parantid:'0',
				source:'公众号'
			   });				  		  
			   var postUrl = that.global.BASE_URL_T3 + '/api/login2/newmsg';			  
			   var config = {
			     method: 'post',
			     url: postUrl,				
			     headers: { 
			       'Authorization': localStorage['access_token'], 
			       'Content-Type': 'application/x-www-form-urlencoded'
			     },
			 	data : data
			   };
			   console.log(config)
			   Vue.axios(config)
			   .then(function (response) {
			     console.log(response);
			 	if (response.data.Status == '0') {
					that.disabled = true;			 	
					Dialog({ message: '意见反馈已提交，请等待服务人员处理。' });
					that.$router.push({ path:'/feedback'  })
			 	} else {
			 		Dialog.alert({
			 			 message: '保存失败请稍后重试。'
			 		})
			 	}
			   })
			   .catch(function (error) {
			     console.log(error);
			   });		
			   
			 }).catch(() => {
			   // on cancel
			 });
			 } else {
			 	Dialog.alert({
			 	  message: '主题、分类、内容不可以为空。'
			 	})
			 }
		 }
	 }
	}
</script>

<style scoped>
.feedback-container {
    background-color: #f7f8fa;
    min-height: 100vh;
    padding-bottom: 80px;
}

.form-content {
    padding: 0;
}

.page-header {
    background: linear-gradient(135deg, #1989fa, #34c759);
    color: #ffffff;
    padding: 30px 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.header-icon {
    margin-bottom: 8px;
}

.header-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 4px;
}

.header-subtitle {
    font-size: 14px;
    opacity: 0.9;
    margin: 0;
}

.form-section {
    background-color: #ffffff;
    margin: 16px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    overflow: hidden;
}

.form-field {
    padding: 16px;
    margin: 0;
    border-bottom: 1px solid #f5f5f5;
}

.form-field:last-child {
    border-bottom: none;
}

.textarea-field :deep(.van-field__control) {
    min-height: 120px;
}

.form-cell {
    padding: 16px;
    margin: 0;
    border-bottom: 1px solid #f5f5f5;
}

.left-align :deep(.van-cell__title) {
    text-align: left;
    flex: none;
    width: 80px;
}

.left-align :deep(.van-cell__value) {
    text-align: left;
    flex: 1;
    color: #323233;
}

.left-align :deep(.van-cell__value--alone) {
    color: #969799;
}

.action-section {
    padding: 16px;
    background-color: #ffffff;
    border-top: 1px solid #f0f0f0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}

.submit-btn {
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 360px) {
    .form-section {
        margin: 12px;
    }
    
    .page-header {
        padding: 24px 16px;
    }
    
    .form-field {
        padding: 14px;
    }
    
    .form-cell {
        padding: 14px;
    }
}

/* 自定义 van-field 样式 */
:deep(.van-field__label) {
    color: #323233;
    font-weight: 500;
    text-align: left;
    width: 80px;
}

:deep(.van-field__control) {
    color: #323233;
    text-align: left;
}

:deep(.van-field__control::placeholder) {
    color: #c8c9cc;
}

:deep(.van-cell__value) {
    color: #969799;
}

:deep(.van-cell__value--alone) {
    color: #323233;
}
</style>